import api from "@/lib/api";
import { toast } from "sonner";

/**
 * Fetches /api/contracts/{id}/preview.pdf with bearer auth and opens it in a new tab.
 * Used by ShareDialog, ContractStudio header, and ContractDetail top bar.
 */
export async function openContractPdfPreview(contractId) {
  if (!contractId) {
    toast.error("Save the draft first");
    return;
  }
  const token = localStorage.getItem("clariva_token");
  const url = `${api.defaults.baseURL}/contracts/${contractId}/preview.pdf`;
  try {
    const r = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const blob = await r.blob();
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, "_blank");
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
  } catch {
    toast.error("Could not generate PDF");
  }
}
